const DEFAULT_TRUE = true
const DEFAULT_FALSE = false

const PROFILE_TYPE_CLIENT = 'Client'
const PROFILE_TYPE_ADVISOR = 'Advisor'
const PROFILE_TYPE_COLLABORATOR = 'Collaborator'

const ADMIN_PROFILE_ID = 1
const PROFILE_ID_RESPONSIBLE = 10000
const RESPONSIBLE_SUPPLIER_PROFILE_ID = 200000
const ADVISOR_ADMIN_PROFILE_ID = 500000
const RESPONSIBLE_DPO_PROFILE_ID = 500002
const ASSISTANT_DPO_PROFILE_ID = 500003
const LEGAL_ADVICE_PROFILE_ID = 500004
const TITULAR_ATTENDANCE_PROFILE_ID = 500005
const OBSERVER_ADVISOR_AUTHOR_PROFILE_ID = 500006
const OBSERVER_ADVISOR_PROFILE_ID = 500007

const DEFAULT_DPO_PROFILES_OPTIONS = [
  {
    id: ASSISTANT_DPO_PROFILE_ID,
    name: 'DPO Assistente',
  },
  { id: LEGAL_ADVICE_PROFILE_ID, name: 'Parecer Jurídico' },
  { id: TITULAR_ATTENDANCE_PROFILE_ID, name: 'Atendimento ao Titular' },
]

const DEFAULT_OBSERVER_PROFILES_OPTIONS = [
  { id: OBSERVER_ADVISOR_PROFILE_ID, name: 'Observador' },
]

const SUPPLIER_PROFILE_OPTIONS = [
  {
    id: RESPONSIBLE_SUPPLIER_PROFILE_ID,
    name: 'Representante de Empresa Fornecedora',
  },
]

const profile = {
  ADMIN_PROFILE_ID,
  ADVISOR_ADMIN_PROFILE_ID,
  DEFAULT_DPO_PROFILES_OPTIONS,
  DEFAULT_OBSERVER_PROFILES_OPTIONS,
  DEFAULT_FALSE,
  DEFAULT_TRUE,
  OBSERVER_ADVISOR_AUTHOR_PROFILE_ID,
  PROFILE_ID_RESPONSIBLE,
  PROFILE_TYPE_ADVISOR,
  PROFILE_TYPE_CLIENT,
  PROFILE_TYPE_COLLABORATOR,
  RESPONSIBLE_DPO_PROFILE_ID,
  SUPPLIER_PROFILE_OPTIONS,
}

export default profile
